import { AppEditionsMarketing } from '@galaxy/marketplace-apps/v1';
import { Observable } from 'rxjs';
import { AppPrice } from '@galaxy/marketplace-apps';

export interface DialogData {
  appPrice$: Observable<AppPrice>;
  currency$: Observable<string>;
  partnerId: string;
  marketId: string;
  productId: string;
  editionsMarketing: AppEditionsMarketing[];
  translationKeys: {
    title: string;
    explanation?: string;
  };
  translationArgs?: {
    productName: string;
    childName: string;
  };
}

export interface DialogResponse {
  productId?: string;
  editionId?: string;
  type: ResponseType;
}

export enum ResponseType {
  EditionSelected = 'edition-selected',
  CompareEditions = 'compare-editions',
  EditionsUnsupported = 'editions-unsupported',
}
